import React from 'react'

function Headerpage() {
  return (
    <div className='header'>
     Movie Recommendation System
    </div>
  )
}

export default Headerpage
